import React from 'react';
import '../styles/About.css';

const coreValues = [
  'Innovation & Technology',
  'Student-Centered Learning',
  'Global Perspective',
  'Integrity & Equity',
  'Excellence in Impact',
];

const milestones = [
  { year: '2010', event: 'ICITY Education Founded' },
  { year: '2015', event: 'Launched Online Learning Platform' },
  { year: '2018', event: '10,000+ Students Enrolled' },
  { year: '2020', event: 'International Accreditation Achieved' },
  { year: '2023', event: '50+ Programs Available' },
];

const leaders = [
  { name: 'Dr. Sarah Johnson', title: 'Chief Executive Officer' },
  { name: 'Prof. Michael Lee', title: 'Head of Academic Affairs' },
  { name: 'Dr. Emily Chen', title: 'Director of Innovation' },
];

const About = () => (
  <section className="about">
    <h2>About Us</h2>

    <div className="mission-vision">
      <div className="block">
        <h3>Our Mission</h3>
        <p>
          ICITY Education is dedicated to providing world-class education through innovative online platforms. We aim to empower learners globally by offering accessible, high-quality educational experiences.
        </p>
      </div>
      <div className="block">
        <h3>Our Vision</h3>
        <p>
          To be a leading educational institution that transforms lives through innovative learning experiences and creates leaders who shape the future.
        </p>
      </div>
    </div>

    <div className="values">
      <h3>Our Core Values</h3>
      <ul>
        {coreValues.map((value, i) => (
          <li key={i}>{value}</li>
        ))}
      </ul>
    </div>

    <div className="journey">
      <h3>Our Journey</h3>
      <div className="timeline">
        {milestones.map((m, i) => (
          <div key={i} className="milestone">
            <span className="year">{m.year}</span>
            <p>{m.event}</p>
          </div>
        ))}
      </div>
    </div>

    <div className="leadership">
      <h3>Leadership Team</h3>
      <div className="leader-grid">
        {leaders.map((l, i) => (
          <div key={i} className="leader-card">
            <h4>{l.name}</h4>
            <p>{l.title}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default About;
